import { Box, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface DetailRowLinkProps {
  label: string;
  value: string | number | null;
  linkTo?: string;
  linkText?: string;
  onClick?: () => void;
}

export const DetailRowLink = ({ label, value, linkTo, linkText = 'Vedi foto', onClick }: DetailRowLinkProps) => {
  const theme = useTheme();

  return (
    <Box display="flex" py={1}>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ minWidth: '250px' }}>
        {label}:
      </Typography>
      <Typography variant="body1">
        {linkTo ? (
          <RouterLink
            to={linkTo}
            style={{
              color: theme.palette.primary.main,
              textDecoration: 'none',
              transition: 'text-decoration 0.2s',
            }}
            onMouseOver={(e) => (e.currentTarget.style.textDecoration = 'underline')}
            onMouseOut={(e) => (e.currentTarget.style.textDecoration = 'none')}
            onClick={onClick}
          >
            {linkText}
          </RouterLink>
        ) : (
          value || '-'
        )}
      </Typography>
    </Box>
  );
};
